<template>
    <div :style="style"
         class="grid-container">
        <div v-for="n in showCount"
             class="grid-filled-rect" />
    </div>
</template>

<script>
export default {
    props: {
        showCount: Number,
        cols: Number
    },
    computed: {
        style() {
            return {
                '--grid-num-columns': this.cols
            }
        }
    }
}
</script>
